import type { OrderProductModel } from '@/types'
import { trimTrailingZeros } from '@/utils/format/trimTrailingZeros'
import { withVat } from '@/utils/price/vat'

export type OrderTotals = {
  itemsCount: number
  opt: string
  rrc: string
}

type TotalsProduct = Pick<
  OrderProductModel,
  'status' | 'quantity' | 'total' | 'totalRetailPrice'
>

export const getOrderTotals = <T extends TotalsProduct>(
  products: T[],
  getEditedQuantity: (product: T) => number | undefined
): OrderTotals => {
  const activeProducts = products.filter(
    (product) => product.status !== 'REJECTED'
  )
  let opt = 0
  let rrc = 0

  activeProducts.forEach((product) => {
    if (product.quantity <= 0) return
    const quantity = getEditedQuantity(product) ?? product.quantity
    opt += (product.total / product.quantity) * quantity
    rrc += withVat((product.totalRetailPrice / product.quantity) * quantity)
  })

  return {
    itemsCount: activeProducts.length,
    opt: trimTrailingZeros(opt),
    rrc: trimTrailingZeros(rrc),
  }
}
